import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
        <div className="label-tag">Checking session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Outlet />;
}
